// THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
export const typography = {
  "fonts": {
    "sans": [
      "Moda Operandi Sans",
      "Arial",
      "sans-serif"
    ],
    "serif": [
      "Moda Operandi Serif",
      "Times New Roman",
      "Times",
      "serif"
    ],
    "code": [
      "Menlo",
      "Monaco",
      "Consolas",
      "Courier New",
      "monospace"
    ]
  },
  "line-heights": [
    1.1,
    1.2,
    1.4,
    1.6
  ],
  "letter-spacing": [
    0,
    "0.02em",
    "0.04em",
    "0.1em"
  ],
  "font-scale": [
    "0.75rem",
    "0.8125rem",
    "1rem",
    "1.25rem",
    "1.5rem",
    "2rem",
    "3rem",
    "3.75rem",
    "6rem"
  ],
  "root-font-size": "16px",
  "text-treatments": {
    "display": {
      "font-size": "6rem",
      "line-height": 1.1,
      "letter-spacing": 0
    },
    "h1": {
      "font-size": "3.75rem",
      "line-height": 1.2,
      "letter-spacing": 0
    },
    "h2": {
      "font-size": "3rem",
      "line-height": 1.1,
      "letter-spacing": 0
    },
    "h3": {
      "font-size": "2rem",
      "line-height": 1.2,
      "letter-spacing": 0
    },
    "h4": {
      "font-size": "1.5rem",
      "line-height": 1.4,
      "letter-spacing": 0
    },
    "h5": {
      "font-size": "1.25rem",
      "line-height": 1.4,
      "letter-spacing": "0.02em"
    },
    "h6": {
      "font-size": "1rem",
      "line-height": 1.4,
      "letter-spacing": "0.04em"
    },
    "body1": {
      "font-size": "0.8125rem",
      "line-height": 1.6,
      "letter-spacing": "0.04em"
    },
    "bold1": {
      "font-size": "0.8125rem",
      "line-height": 1.6,
      "letter-spacing": "0.1em",
      "font-weight": "bold"
    },
    "body2": {
      "font-size": "0.75rem",
      "line-height": 1.4,
      "letter-spacing": "0.04em"
    },
    "eyebrow": {
      "font-size": "0.75rem",
      "line-height": 1.4,
      "letter-spacing": "0.1em",
      "text-transform": "uppercase"
    }
  }
};